import React, { memo } from 'react';
import Button from '@material-ui/core/Button';
import { useStyles, useStylesButton } from './styles';

const BottomButtonComponent = ({ disabled, handleClick }) => {
  const classes = useStyles();
  const classesButton = useStylesButton();

  return (
    <div className={classes.SliderBottomContainer}>
      <Button
        disabled={disabled}
        variant="contained"
        onClick={handleClick}
        classes={classesButton}
      >
        Next
      </Button>
    </div>
  );
};

export default memo(BottomButtonComponent);
